import imageCompression from 'browser-image-compression';

/**
 * Options for image compression using browser-image-compression
 */
export interface ImageCompressionOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  useWebWorker?: boolean;
  maxIteration?: number;
  exifOrientation?: number;
  fileType?: string;
  initialQuality?: number;
  signal?: AbortSignal;
}

/**
 * Compress and resize an image file in the browser before uploading
 * @param file The input File (image)
 * @param options Optional imageCompression options
 * @returns Promise<File> The compressed image file
 */
export async function compressImageFile(
  file: File,
  options: ImageCompressionOptions = {
    maxWidthOrHeight: 600,
    maxSizeMB: 0.3, // ~300KB
    useWebWorker: true,
    fileType: 'image/webp',
    initialQuality: 1,
  }
): Promise<File> {
  return await imageCompression(file, options);
}

